import { Button, Typography, useTheme } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ContentTitle from "components/common/ContentTitle";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import useSmartSubName from "components/request-document/hooks/useSmartSubName";
import { HOME_TAB } from "libs/constant/Step";
import mime from "mime";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { clearSmartFormStep, setHomeTab } from "redux/modules/uiSlice";
import { submitSmartFormSlice } from "redux/modules/visaForm";
import ReportService from "services/ReportService";

export default function SummarizeStep() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const subName = useSmartSubName();

  const { draftId, smartform } = useSmartForm();
  const canEdit = useSelector(canEditForm);
  const onClickNext = () => {
    dispatch(submitSmartFormSlice.actions.clearAsyncState());
    dispatch(clearSmartFormStep());
    dispatch(setHomeTab(HOME_TAB.INFORMATION));
  };

  const onClickViewDocument = async () => {
    const fileFullName = `${draftId}.pdf`;
    const blob = await ReportService.getResultSmartfromDetail({ draftId });

    const blobFile = new File([blob], fileFullName, {
      type: mime.getType(".pdf"),
    });

    window.open(URL.createObjectURL(blobFile), "_blank");
  };

  return (
    <div>
      {false && (
        <ContentTitle
          title="Application Form"
          subTitle={`APPLICATION FOR QUALIFICATION ENDORSEMENT FOR ${(smartform?.smartserviceName ?? 'WORKPERMIT')?.toUpperCase()} `}
        />
      )}

      <div
        style={{
          height: 3,
          width: "100%",
          backgroundColor: theme.palette.warning.main,
        }}
      />

      <Typography
        variant="h3"
        style={{
          textAlign: "center",
          color: theme.palette.secondary.main,
          marginTop: 54,
        }}
      >
        Thank you for your time
      </Typography>
      <div style={{ display: "flex", justifyContent: "center", marginTop: 24 }}>
        <CheckCircleIcon
          style={{
            color: theme.palette.success.main,
            fontSize: 100,
          }}
        />
      </div>
      <Typography
        variant="h5"
        style={{
          textAlign: "center",
          marginTop: 34,
          color: theme.palette.success.main,
        }}
      >
        The system has received your documents
      </Typography>
      <Typography variant="h6" style={{ textAlign: "center", marginTop: 24 }}>
        The documents are in the reviewing process
      </Typography>
      <Typography variant="h6" style={{ textAlign: "center", marginTop: 0 }}>
        You Will be able to view the application status in a while
      </Typography>
      <Typography
        variant="h6"
        style={{
          textAlign: "center",
          marginTop: 8,
          // color: theme.palette.primary.main,
        }}
      >
        or
      </Typography>
      <Typography variant="h6" style={{ textAlign: "center", marginTop: 8 }}>
        View the submitted documents below
      </Typography>
      {/* <div style={{ display: "flex", justifyContent: "center", marginTop: 16 }}>
        <Button
          variant="outlined"
          color="secondary"
          style={{
            width: 200,
            height: 50,
            borderWidth: 2,
            fontWeight: "bold",
            marginTop: 16,
          }}
          onClick={onClickViewDocument}
        >
          <PrintIcon style={{ marginRight: 8 }} />
          View Document
        </Button>
      </div> */}
      {canEdit && (
        <div style={{ display: "flex", marginTop: 50 }}>
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            style={{ height: 50, fontWeight: "bold" }}
            onClick={onClickNext}
          >
            Done
          </Button>
        </div>
      )}
    </div>
  );
}
